
import { PropType, defineComponent } from 'vue';
import { Transaction } from '~/interfaces/transactions';

export default defineComponent({
  name: 'TransactionsTableItem',

  props: {
    data: { type: Object as PropType<Transaction>, default: null },
    colorCodedNegatives: { type: Boolean, default: false },
  },

  data: () => ({
    expanded: false,
  }),

  computed: {
    maxHeight() {
      return this.expanded ? `${(this.$refs.content as HTMLElement).scrollHeight}px` : 0;
    },

    amount() {
      const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
      });

      return formatter.format(this.data.amount);
    },

    getAmountClasses() {
      if (this.data.status === 'Failed') {
        return 'transactions-table-item__amount--failed';
      }

      if (this.colorCodedNegatives && this.data.amount < 0) {
        return 'transactions-table-item__amount--color-coded';
      }

      return '';
    },
  },
});
